import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { media } from 'components/styles'

const CardBorder = styled.div`
  width: ${props => props.width};
  height: ${props => props.height};
  margin: 0.5em;
  border-radius: 6px;
  background-color: #eaf7ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: ${props => props.pointer ? 'pointer' : 'default'};
  position: relative;
  transition: background .8s linear;
  overflow: hidden;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
  line-height: 100%;
  text-align: center;
  outline: none;
  ${props => props.styleRaw}
  ${media.small`font-size: 12px;`}
  ${media.normal`font-size: 15px;`}
  ${media.huge`font-size: 18px;`}

  &:hover {
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
    _border-color: transparent;
  }

  &:focus {
    outline: none;
  }
`

class Card extends Component {
  render () {
    const { width, height, onClick, children, eventListeners, pointer, styleRaw } = this.props

    return (
      <CardBorder
        width={width}
        height={height}
        onClick={onClick}
        {...eventListeners}
        pointer={pointer}
        styleRaw={styleRaw}
      >
        {children}
      </CardBorder>
    )
  }
}

Card.defaultProps = {
  width: '160px',
  height: '160px',
  onClick: () => null,
  eventListeners: {},
  pointer: false,
  styleRaw: ''
}

Card.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  onClick: PropTypes.func,
  eventListeners: PropTypes.object,
  pointer: PropTypes.bool,
  styleRaw: PropTypes.string
}

export default Card



// WEBPACK FOOTER //
// ./src/components/shared/Card.js